import type { Components, Theme } from '@mui/material/styles';

export const MuiButton: Components<Omit<Theme, 'components'>>['MuiButton'] = {
  defaultProps: {
    disableElevation: true,
  },
  styleOverrides: {
    root: {
      borderRadius: 8,
      fontWeight: 400,
      textTransform: 'none',
      boxShadow: 'none',
      transition: 'background 0.2s, color 0.2s, border 0.2s',
      '&:focus-visible': {
        outline: '2px solid',
        outlineColor: '#305DFF',
        outlineOffset: 2,
      },
    },
    sizeLarge: {
      fontSize: '15px',
      padding: '8px 22px',
      lineHeight: '26px',
    },
    sizeMedium: {
      fontSize: '14px',
      padding: '6px 16px',
      lineHeight: '24px',
    },
    sizeSmall: {
      fontSize: '13px',
      padding: '4px 10px',
      lineHeight: '22px',
    },
  },
  variants: [
    {
      props: { variant: 'contained', color: 'primary' },
      style: {
        color: '#FFFFFF',
        background: '#07105F',
        boxShadow: 'none',
        '&:hover': {
          background: '#0C21A3',
        },
        '&:focus-visible': {
          background: '#011BE6',
          boxShadow: 'none',
        },
        '&.Mui-disabled': {
          color: '#FFFFFF',
          background: '#A3A9B8',
          boxShadow: 'none',
        },
      },
    },
    {
      props: { variant: 'contained', color: 'secondary' },
      style: {
        color: '#0A0A3C',
        background: '#E9EBF0',
        boxShadow: 'none',
        '&:hover': {
          background: '#D3D7E0',
        },
        '&:focus-visible': {
          background: '#A3A9B8',
          boxShadow: 'none',
        },
        '&.Mui-disabled': {
          color: '#A3A9B8',
          background: '#F3F4F8',
          boxShadow: 'none',
        },
      },
    },
    {
      props: { variant: 'contained', color: 'error' },
      style: {
        color: '#FFFFFF',
        background: '#F23B5D',
        boxShadow: 'none',
        '&:hover': {
          background: '#E02B4C',
        },
        '&:focus-visible': {
          background: '#C91C3A',
          boxShadow: 'none',
        },
        '&.Mui-disabled': {
          color: '#FFFFFF',
          background: '#F8B6C3',
          boxShadow: 'none',
        },
      },
    },
    {
      props: { variant: 'outlined', color: 'primary' },
      style: {
        color: '#0D0D48',
        background: 'transparent',
        border: '1.5px solid #0D0D48',
        '&:hover': {
          background: '#F5F6FA',
          borderColor: '#032497',
        },
        '&:focus-visible': {
          borderColor: '#305DFF',
          boxShadow: 'none',
        },
        '&.Mui-disabled': {
          color: '#AFB6C4',
          borderColor: '#D6DBE7',
        },
      },
    },
    {
      props: { variant: 'outlined', color: 'error' },
      style: {
        color: '#DD0038',
        background: 'transparent',
        border: '1.5px solid #DD0038',
        '&:hover': {
          background: '#FDE6EB',
          borderColor: '#EC0B44',
        },
        '&:focus-visible': {
          borderColor: '#FF2D61',
          boxShadow: 'none',
        },
        '&.Mui-disabled': {
          color: '#AFB6C4',
          borderColor: '#D6DBE7',
        },
      },
    },
    {
      props: { variant: 'text', color: 'primary' },
      style: {
        color: '#0D0D48',
        background: 'transparent',
        boxShadow: 'none',
        '&:hover': {
          background: '#F5F6FA',
        },
        '&:focus-visible': {
          background: '#F5F6FA',
        },
        '&.Mui-disabled': {
          color: '#AFB6C4',
        },
      },
    },
    {
      props: { variant: 'text', color: 'error' },
      style: {
        color: '#DD0038',
        background: 'transparent',
        boxShadow: 'none',
        '&:hover': {
          background: '#FDE6EB',
        },
        '&:focus-visible': {
          background: '#FDE6EB',
        },
        '&.Mui-disabled': {
          color: '#AFB6C4',
        },
      },
    },
  ],
};
